<template>
    <div class="locations-list container">

        <div class="row row-cols-1 row-cols-md-4 g-4 justify-content-evenly">

            <div v-for="location in locations.value.results" :key="location.id">
                <SingleLocation :location="location"></SingleLocation>
            </div>

        </div>
    </div>
</template>

<script>
import { onMounted, onUnmounted, onUpdated } from 'vue'
import SingleLocation from './Location/SingleLocation.vue'

export default {
    props:['locations'],
    components: { SingleLocation },
    setup(props) {
        onMounted(  () => { console.log( 'LocationsList Mounted' ) } )
        onUnmounted(() => { console.log( 'LocationsList UnMounted' ) } )
        onUpdated(  () => { console.log( 'LocationsList Updated' ) } )
    }
}
</script>

<style>
</style>